/* unplugin-vue-components disabled */import script from "./ProductTable2.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTable2.vue?vue&type=script&setup=true&lang=js"

import "./ProductTable2.vue?vue&type=style&index=0&id=878f1066&lang=scss"

const __exports__ = script;

export default __exports__